// src/modules/app-views/_apps/appmulti/plans/pages/Init/actions/menuButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { DatabaseOutlined, ImportOutlined } from '@ant-design/icons';
import showMigrationDocumentModal from 'components/core/migration/MigrationDocumentModal';
import showMigrationModal from 'components/core/migration/MigrationSettingsModal';
import { dropdownParameters } from 'layouts/Pages/PageHeader/dropdownMenus';

// *******************************************************************************
// MENU BUTTON
// *******************************************************************************
const plansInitMenuButton = () => {
  return {
    action: 'dropdownMenu',
    dropdownItems: [
      {
        key: 'importPlan',
        label: 'migrate_document',
        icon: <ImportOutlined />,
        // Hide item if plans migration token is not active
        hidden: ({ storedSubscription }) => {
          const tokens = storedSubscription?.migrationTokens || [];
          const plansToken = tokens.find(t => t.collectionName === 'plans');
          return !plansToken?.isActive;
        },
        onClick: ({ refresh }) => {
          showMigrationDocumentModal({
            onSuccess: () => {
              if (typeof refresh === 'function') {
                refresh();
              }
            },
          });
        },
      },
      'divider',
      { ...dropdownParameters, onClick: () => {} },
      {
        key: 'plansMigrationSettings',
        label: 'migrator',
        icon: <DatabaseOutlined />,
        onClick: ({ refresh }) => {
          showMigrationModal({
            onSuccess: () => {
              if (typeof refresh === 'function') {
                refresh();
              }
            },
          });
        },
      },
    ],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default plansInitMenuButton;
